// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forumThreadStatus {
  color: red;
  clear: left;
}

.postTypeComboLabel {
  float: right;
  clear: right;
}

.postTypeLabel {
  color: red;
  text-align: right;
  clear: right;
}

.postTextBorder {
  border-style: solid;
  padding: 0.25em;
  margin: 0.25em;
  border-color: #3399f3;
  border-width: 1px;
}

.postTextArea {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 1em;
}

.addPostButton {
  margin: 0.5em !important; /* override bootstrap btn margin-bottom 0 */
}

hr.postRule {
  border-top: 1px solid #3399f3;
}
`, "",{"version":3,"sources":["webpack://./src/css/cldrForum.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB,EAAE,2CAA2C;AACvE;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":[".forumThreadStatus {\n  color: red;\n  clear: left;\n}\n\n.postTypeComboLabel {\n  float: right;\n  clear: right;\n}\n\n.postTypeLabel {\n  color: red;\n  text-align: right;\n  clear: right;\n}\n\n.postTextBorder {\n  border-style: solid;\n  padding: 0.25em;\n  margin: 0.25em;\n  border-color: #3399f3;\n  border-width: 1px;\n}\n\n.postTextArea {\n  width: 100%;\n  box-sizing: border-box;\n  margin-bottom: 1em;\n}\n\n.addPostButton {\n  margin: 0.5em !important; /* override bootstrap btn margin-bottom 0 */\n}\n\nhr.postRule {\n  border-top: 1px solid #3399f3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
